import type { RaffleBase } from "./types";
import { getRaffleProgress } from "./raffleProgress";
import type { RaffleProgressSource } from "./raffleProgress";
import type { RaffleRole } from "./selectHistory";

export type RaffleBadge = RaffleRole | "won";

export type RaffleBadgeSource = Pick<RaffleBase, "my_prize_usdt"> &
  Partial<Pick<RaffleBase, "is_winner" | "status">> &
  RaffleProgressSource;

// Выигрыш важнее роли: его зритель ищет в списке в первую очередь.
export const getRaffleBadge = (
  raffle: RaffleBadgeSource,
  role: RaffleRole | null,
): RaffleBadge | null =>
  raffle.is_winner || raffle.my_prize_usdt ? "won" : role;

// Без бейджа показываем, насколько выполнены условия. Когда они выполнены,
// бэк ставит is_participant — и вместо прогресса появляется Joined.
// В истории это прогресс, с которым зритель встретил конец розыгрыша.
export const getCardProgress = (raffle: RaffleBadgeSource): number | null =>
  getRaffleProgress(raffle);
